import React, { Component } from "react";
import "../css/contactPage.css";

class ContactPage extends Component {
    render() {
        return (
            <div className="contactHolder">
                <div className="contactHolderInner">
                    <div className="aboutHeaderText">Contact Us</div>

                    <div style={{ width: 90 + "%", marginRight: "auto", marginLeft: "auto" }}>
                    <div className="contactSmallerText"><strong>Customer Service & Sales</strong><br /><a style={{ textDecoration: "none", color: "#0098c5", fontSize: "25px" }} href="tel:2519786088" data-rel="external">251-978-6088</a> <br />(Mon-Fri 9AM-5PM CST)</div>
                    <div className="contactSmallerText"><strong>Email</strong><br /><a style={{ textDecoration: "none", color: "#0098c5", fontSize: "25px" }} href="mailto:contact@houseplanstore.com" data-rel="external">contact@houseplanstore.com</a> <br /></div>
                    <div className="contactSmallerText"><strong>Corporate Office</strong><br />Chatham Design Group, Inc<br />Post Office Box 2234 790 C Daphne Ave.<br />Daphne, AL 36526</div>
                    <br />
                    <div className="contactSmallerText"><a style={{ textDecoration: "none", color: "#0098c5", fontSize: "18px" }} href="https://www.houseplanstore.com/terms-conditions/" >Terms & Conditions</a></div>
                    <div className="contactSmallerText"><a style={{ textDecoration: "none", color: "#0098c5", fontSize: "18px" }} href="https://www.houseplanstore.com/privacy/">Privacy & Cookies</a></div>


                    <br />
                    </div>

                </div>
            </div>
        );
    }
}

export default ContactPage;